import moment from "moment-jalaali";

export const TodayObj = (intervalMin) => {
  moment.locale("en");

  let now = new Date(Date.now() + intervalMin * 60 * 60 * 1000);
  let todayYear = Number(now.getFullYear(now));
  let todayMonth = Number(now.getMonth(now));
  let todayDate = Number(now.getDate(now));
  return {
    Day: todayDate,
    Month: todayMonth,
    Year: todayYear,
    Hour: moment(now).format("HH"),
    Min: moment(now).format("mm"),
  };
};
